import React, { useRef, useState } from "react";

const images = [
  { id: 1, src: "/gallery/img1.jpg", category: "Factory", title: "Manufacturing Unit" },
  { id: 2, src: "/gallery/img2.jpg", category: "Production", title: "Production Line" },
  { id: 3, src: "/gallery/img3.jpg", category: "Team", title: "Our Skilled Team" },
  { id: 4, src: "/gallery/img4.jpg", category: "Packaging", title: "Product Packaging" },
  { id: 5, src: "/gallery/img5.jpg", category: "Factory", title: "Workshop Area" },
  { id: 6, src: "/gallery/img6.jpg", category: "Production", title: "Quality Check" },
  { id: 7, src: "/gallery/img7.jpg", category: "Factory", title: "Manufacturing Unit" },
  { id: 8, src: "/gallery/img8.jpg", category: "Production", title: "Production Line" },
  { id: 9, src: "/gallery/img9.jpg", category: "Team", title: "Our Skilled Team" },
  { id: 10, src: "/gallery/img10.jpg", category: "Packaging", title: "Product Packaging" },
  { id: 11, src: "/gallery/img11.jpg", category: "Factory", title: "Workshop Area" },
  { id: 12, src: "/gallery/img12.jpg", category: "Production", title: "Quality Check" },
  { id: 13, src: "/gallery/img13.jpg", category: "Factory", title: "Manufacturing Unit" },
  { id: 14, src: "/gallery/img14.jpg", category: "Production", title: "Production Line" },
  { id: 15, src: "/gallery/img15.jpg", category: "Team", title: "Our Skilled Team" },
  { id: 16, src: "/gallery/img16.jpg", category: "Packaging", title: "Product Packaging" },
  { id: 17, src: "/gallery/img17.jpg", category: "Factory", title: "Workshop Area" },
  { id: 18, src: "/gallery/img18.jpg", category: "Production", title: "Quality Check" },
  { id: 19, src: "/gallery/img19.jpg", category: "Factory", title: "Manufacturing Unit" },
  { id: 20, src: "/gallery/img20.jpg", category: "Production", title: "Production Line" },
  { id: 21, src: "/gallery/img21.jpg", category: "Team", title: "Our Skilled Team" },
  { id: 22, src: "/gallery/img22.jpg", category: "Packaging", title: "Product Packaging" },
  { id: 23, src: "/gallery/img23.jpg", category: "Factory", title: "Workshop Area" },
  { id: 24, src: "/gallery/img24.jpg", category: "Production", title: "Quality Check" },
  { id: 25, src: "/gallery/img25.jpg", category: "Factory", title: "Manufacturing Unit" },
  { id: 26, src: "/gallery/img26.jpg", category: "Production", title: "Production Line" },
  { id: 27, src: "/gallery/img27.jpg", category: "Team", title: "Our Skilled Team" },
  { id: 28, src: "/gallery/img28.jpg", category: "Packaging", title: "Product Packaging" },
  { id: 29, src: "/gallery/img29.jpg", category: "Factory", title: "Workshop Area" },
  { id: 30, src: "/gallery/img30.jpg", category: "Production", title: "Quality Check" },
  { id: 31, src: "/gallery/img31.jpg", category: "Factory", title: "Manufacturing Unit" },
  { id: 32, src: "/gallery/img32.jpg", category: "Production", title: "Production Line" },
  { id: 33, src: "/gallery/img33.jpg", category: "Team", title: "Our Skilled Team" },
  { id: 34, src: "/gallery/img34.jpg", category: "Packaging", title: "Product Packaging" },
  { id: 35, src: "/gallery/img35.jpg", category: "Factory", title: "Workshop Area" },
  { id: 36, src: "/gallery/img36.jpg", category: "Production", title: "Quality Check" },
  { id: 37, src: "/gallery/img37.jpg", category: "Factory", title: "Manufacturing Unit" },
  { id: 38, src: "/gallery/img38.jpg", category: "Production", title: "Production Line" },
  { id: 39, src: "/gallery/img39.jpg", category: "Team", title: "Our Skilled Team" },
  { id: 40, src: "/gallery/img40.jpg", category: "Packaging", title: "Product Packaging" },
  { id: 41, src: "/gallery/img41.jpg", category: "Factory", title: "Workshop Area" },
  { id: 42, src: "/gallery/img42.jpg", category: "Production", title: "Quality Check" },
  { id: 43, src: "/gallery/img43.jpg", category: "Factory", title: "Manufacturing Unit" },
  { id: 44, src: "/gallery/img44.jpg", category: "Production", title: "Production Line" },
  { id: 45, src: "/gallery/img45.jpg", category: "Team", title: "Our Skilled Team" },
  { id: 46, src: "/gallery/img46.jpg", category: "Packaging", title: "Product Packaging" },
  { id: 47, src: "/gallery/img47.jpg", category: "Factory", title: "Workshop Area" },
  { id: 48, src: "/gallery/img48.jpg", category: "Production", title: "Quality Check" }
];

const categories = ["All", "Factory", "Production", "Team", "Packaging"];

function Gallery() {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [activeImage, setActiveImage] = useState(null);
  const sliderRef = useRef(null);

  const filteredImages =
    selectedCategory === "All"
      ? images
      : images.filter((img) => img.category === selectedCategory);

  const scroll = (direction) => {
    const container = sliderRef.current;
    const scrollAmount = container.offsetWidth;
    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth"
    });
  };

  return (
    <section id="gallery" className="bg-gray-100 py-20 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-extrabold text-black mb-3">
            Our Factory Gallery
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Explore our manufacturing unit, production process, packaging department and skilled workforce behind BNM Wipers. 
            We specialize in high-quality wiper manufacturing, bulk supply, industrial cleaning solutions and export-grade production.
          </p>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap justify-center gap-4 mb-10">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`px-6 py-2 rounded-full font-semibold transition-all duration-300 border hover:scale-105
                ${
                  selectedCategory === cat
                    ? "bg-blue-700 text-white border-blue-700 shadow-lg"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-blue-700 hover:text-white"
                }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Slider Controls */}
        <div className="flex justify-end gap-4 mb-6">
          <button
            onClick={() => scroll("left")}
            className="p-2 px-6 rounded-full border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white transition-all duration-300 hover:scale-105"
          >
            ◀
          </button>
          <button
            onClick={() => scroll("right")}
            className="p-2 px-6 rounded-full border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white transition-all duration-300 hover:scale-105"
          >
            ▶
          </button>
        </div>

        {/* Horizontal Gallery */}
        <div
            ref={sliderRef}
            className="grid grid-rows-2 auto-cols-max grid-flow-col gap-6 overflow-x-auto scrollbar-hide scroll-smooth snap-x"
            >

          {filteredImages.map((img) => (
            <div
              key={img.id}
              className="min-w-[280px] md:min-w-[300px] lg:min-w-[320px] snap-center group relative overflow-hidden rounded-3xl shadow-lg cursor-pointer"
              onClick={() => setActiveImage(img)}
            >
              <img
                src={img.src}
                alt={img.title}
                className="w-full h-72 object-cover transform group-hover:scale-110 transition-transform duration-500"
              />

              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition duration-300 flex flex-col justify-end p-6">
                <h3 className="text-white font-bold text-lg">
                  {img.title}
                </h3>
                <span className="text-sm text-gray-300">
                  {img.category}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {activeImage && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center px-4">
          <div className="relative max-w-4xl w-full">
            <button
              className="absolute -top-12 right-0 text-white text-3xl hover:text-red-400 transition"
              onClick={() => setActiveImage(null)}
            >
              ✕
            </button>
            <img
              src={activeImage.src}
              alt={activeImage.title}
              className="w-full max-h-[80vh] object-contain rounded-2xl shadow-2xl"
            />
            <div className="text-center mt-4">
              <h3 className="text-white text-xl font-bold">
                {activeImage.title}
              </h3>
              <p className="text-gray-400">
                {activeImage.category}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Gallery;